import { useNavigate } from 'react-router';
import LocaleLink from '@/components/LocaleLink';
import { useLocale } from '@/hooks/useLocale';
import { metaFor } from '@/copy/meta-en';

/* Localized static not-found view (owner spec, Gate A + Decision 19,
 * 2026-09-01): renders inside the locale chrome (TopNav + Footer), big title,
 * one-sentence body, teal Go-home primary and a Go-back secondary. Honest to
 * crawlers via useDocumentHead's noindex on unmatched paths. Real HTTP 404
 * status arrives with the prerender phase. */
export default function NotFound() {
  const { locale } = useLocale();
  const nf = metaFor(locale).notFound;
  const navigate = useNavigate();

  return (
    /* paddingBlock only — a padding shorthand here would zero out the inline
     * gutters. paddingInline approximates other pages' per-page 64px→24px
     * .mkt-container overrides with a continuous clamp (they use a hard 768px
     * breakpoint; close enough for a 404). No CSS file of its own. */
    <main
      className="mkt-container"
      style={{
        paddingBlock: 120,
        paddingInline: 'clamp(24px, 5vw, 64px)',
        textAlign: 'center',
      }}
    >
      <h1 className="mkt-h1" style={{ marginInline: 'auto' }}>{nf.heading}</h1>
      <p className="mkt-lead" style={{ marginInline: 'auto' }}>{nf.body}</p>
      <div
        style={{
          display: 'flex',
          gap: 12,
          justifyContent: 'center',
          flexWrap: 'wrap',
          marginBlockStart: 32,
        }}
      >
        <LocaleLink className="mkt-cta-primary" to="/">
          {nf.home}
        </LocaleLink>
        {/* No-op on a fresh tab with no history — acceptable per Decision 17. */}
        <button type="button" className="mkt-cta-ghost" onClick={() => void navigate(-1)}>
          {nf.goBack}
        </button>
      </div>
    </main>
  );
}
